import { render, staticRenderFns } from "./c_About_Locks.vue?vue&type=template&id=f90dd16e&scoped=true&"
import script from "./c_About_Locks.vue?vue&type=script&lang=js&"
export * from "./c_About_Locks.vue?vue&type=script&lang=js&"
import style0 from "./c_About_Locks.vue?vue&type=style&index=0&id=f90dd16e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90dd16e",
  null
  
)

export default component.exports